module.exports = __webpack_public_path__ + "img/icon_header_search_w.fa657fbf.svg";